import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import ChemicalForm from "./ChemicalForm";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  addMasterRecord,
  // deleteMasterRecord,
  // fetchMasterListById,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { AlertModal } from "../../../common/AlertModal";
import { formatDateTime } from "../../../../common/Validations";
import ItemService from "../../../../services/commonService";
import ChemicalPopover from "./ChemicalPopover";

const Chemical = ({ embedded = false }) => {
  let userData = useSelector((state) => state?.user.data); // User Details from Store

  const [open, setOpen] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  // const [selectedItem, setSelectedItem] = useState([]);
  const [selectedBatchDept, setSelectedBatchDept] = useState("");
  const [editDept, setEditDept] = useState();
  const [confirmModel, setConfirmModel] = useState(false);
  const [confirmationBodyMsg, setConfirmationBodyMsg] = useState(
    "Are you sure you want to close the existing batch?",
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = () => {
    setOpen(false);
  };

  const allowedCategories = ["OPERATOR", "TEAMLEAD", "SUPERVISOR"]; // add as many as you need

  const columnsData = [
    {
      name: "Action",
      width: "140px",
      cell: (row) => {
        if (row.status === "Inactive") {
          return <i className="bi bi-x-circle fs-3 danger"></i>;
        } else if (allowedCategories.includes(userData?.category)) {
          return <i className="bi bi-check2-circle fs-3 success"></i>;
        } else {
          return (
            <button
              className="btnTable"
              onClick={() => closeBatchConfirm(row.deptCode)}
              disabled={row.status === "Inactive"}
            >
              {t("msg_master_list.msg_chemical.close")}
            </button>
          );
        }
      },
    },
    {
      name: t("msg_common.status"),
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          {row.status === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.status === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.status
          )}
        </>
      ),
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_chemical.batch_no"),
      selector: (row) => row.chemicalBatchNo,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.chemicalBatchNo}
          </span>
        </>
      ),
    },
    {
      name: t("msg_master_list.msg_chemical.departmentName"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {row?.deptName?.split(" - ")[0]}{" "}
            {row?.machineCode && (
              <span className="badge-amber">{row?.machineCode}</span>
            )}
          </p>
          <p className="m-0 p-0 ">{row?.deptName?.split(" - ")[1]} </p>
        </div>
      ),
    },
    {
      name: "Chemicals Value",
      width: "150px",
      cell: (row) => (
        <span
          style={{
            cursor: "pointer",
            color: "#1442b7",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => handleChemicalListClick(e, row)}
        >
          <i className="bi bi-flask"></i> &nbsp; Chemical List
        </span>
      ),
      sortable: false,
    },
    {
      name: t("msg_master_list.msg_chemical.createdBy"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.loginUserId} </p>
          <p className="m-0 p-0 ">{row.loginUserName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row.dbDateTimeCreated)}
          </p>
        </div>
      ),
      width: "145px",
    },
    {
      name: "Closed By",
      selector: (row) => row.modifiedById,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.modifiedById} </p>
          <p className="m-0 p-0 ">{row.modifiedByName} </p>
        </div>
      ),
    },
    {
      name: "Closed Date",
      selector: (row) => row.dbDateTimeUpdated,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row.dbDateTimeUpdated)}
          </p>
        </div>
      ),
      width: "145px",
    },
  ];

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.CHEMICAL.ADD;
    } else {
      param.method = Constants.MASTER.CHEMICAL.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      // console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        if (!edit) {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_chemical.success_message"),
            2000,
          );
        } else {
          toastFunc(
            Constants.MASTER.TOAST.success,
            t("msg_master_list.msg_chemical.update_success_message"),
            2000,
          );
        }
        dispatch(fetchMasterList(Constants.MASTER.CHEMICAL)); // userSlice store
        setOpen(false);
      } else if (res?.payload?.errorcode === 1001) {
        // setError(res?.payload?.message);
        // setIsError(true);
        setConfirmationBodyMsg(
          `${res?.payload?.message}, Are you sure you want to close the existing batch?`,
        );
        closeBatchConfirm(data.deptCode);
      } else {
        setError(t("msg_master_list.msg_chemical.chemical_add_error"));
        setIsError(true);
      }
    });
  };

  const closeBatchConfirm = (deptCode) => {
    setSelectedBatchDept(deptCode);
    setConfirmModel(true);
  };

  const handleCloseBatch = async () => {
    let param = {
      deptCode: selectedBatchDept,
    };
    // console.log(">> selectedBatchDept", selectedBatchDept);

    await ItemService.updateChemicalByDept(param).then((item) => {
      // console.log(">> Update Details res!", item);
      if (item?.status === 200) {
        dispatch(fetchMasterList(Constants.MASTER.CHEMICAL));
        toastFunc(Constants.MASTER.TOAST.success, item.message, 2000);
        setConfirmModel(false);
      } else {
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_chemical.invalid_input"),
          4000,
        );
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditDept(data);
    }
    setOpen(true);
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store
  let rowsData = masterList[Constants.MASTER.CHEMICAL.name]?.data;

  const handleSearch = () => {
    const param = {
      ...Constants.MASTER.CHEMICAL,
      value: searchValue,
    };
    if (searchValue) {
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  // const handleRowSelected = ({ selectedRows }) => {
  //   const selectDept = selectedRows.map((item) => item.deptCode);
  //   setSelectedItem([...selectDept]);
  // };

  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetError = () => {
    setIsError(false);
    setError("");
  };

  const onSearchChange = (e) => {
    if (e.target.value) {
      setSearchValue(e.target.value);
    } else {
      dispatch(fetchMasterList(Constants.MASTER.CHEMICAL));
      setSearchValue(e.target.value);
    }
  };

  // Popover state: open, position, chemicals
  const [popover, setPopover] = useState({
    open: false,
    x: 0,
    y: 0,
    chemicals: [],
  });

  // Handle click on "Chemical List"
  const handleChemicalListClick = (event, row) => {
    event.stopPropagation();
    setPopover({
      open: true,
      x: event.clientX,
      y: event.clientY,
      chemicals: row.values,
    });
  };

  // Close popover
  const handlePopoverClose = () => {
    setPopover((p) => ({ ...p, open: false }));
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.CHEMICAL)); // userSlice store

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const PageContainer = embedded ? "section" : "main";

  return (
    <PageContainer
      className={embedded ? "" : "main"}
      id={embedded ? undefined : "main"}
    >
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {t("msg_master_list.msg_chemical.title")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_chemical.details")}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide">
          <Form>
            <Form.Group>
              <InputGroup>
                <Form.Control
                  type="search"
                  placeholder={t("msg_common.search_placeholder")}
                  onChange={(e) => onSearchChange(e)}
                />
                <InputGroup.Text>
                  <i className="bi bi-search" onClick={handleSearch}></i>
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        // selectableRows
        handleClose
        handleOpen={handleOpen}
        // handleRowSelected={handleRowSelected}
        deleteEnabled={false}
      />

      <ChemicalPopover
        open={popover.open}
        x={popover.x}
        y={popover.y}
        chemicals={popover.chemicals}
        onClose={handlePopoverClose}
      />

      {open && (
        <ChemicalForm
          data={editDept}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></ChemicalForm>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_chemical.delete_confirm_heading")}
          bodyMessage={confirmationBodyMsg}
          onOk={() => handleCloseBatch()}
          onHide={() => setConfirmModel(false)}
          type={"common"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_chemical.chemical_add_error")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}

      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </PageContainer>
  );
};

export default Chemical;
